import React from "react";

import NewsCard from "./NewsCard";

export default function NewsList({ items = [], loading, onOpen }) {
  if (loading) {
    return (
      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {Array.from({ length: 6 }).map((_, index) => (
          <div
            key={index}
            className="overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-950"
          >
            <div className="aspect-[16/10] animate-pulse bg-slate-200 dark:bg-slate-800" />
            <div className="space-y-4 p-5">
              <div className="h-5 w-24 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
              <div className="h-7 w-4/5 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
              <div className="space-y-2">
                <div className="h-4 w-full animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
                <div className="h-4 w-10/12 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
                <div className="h-4 w-7/12 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (!items.length) {
    return (
      <div className="rounded-[2rem] border border-dashed border-slate-300 bg-white px-6 py-12 text-center shadow-sm dark:border-slate-700 dark:bg-slate-950">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-3xl bg-[#1277B9]/10 text-[#1277B9] dark:bg-[#1277B9]/20 dark:text-sky-300">
          <span className="text-2xl">📰</span>
        </div>

        <h2 className="mt-5 text-xl font-bold text-slate-950 dark:text-white">
          Aucune actualité trouvée
        </h2>

        <p className="mx-auto mt-2 max-w-xl text-sm leading-7 text-slate-600 dark:text-slate-300">
          Essayez avec un autre mot-clé, une autre année ou réinitialisez les
          filtres.
        </p>
      </div>
    );
  }

  return (
    <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
      {items.map((item, index) => (
        <NewsCard
          key={item.id}
          item={item}
          onOpen={onOpen}
          delay={Math.min(index * 35, 180)}
        />
      ))}
    </div>
  );
}